import {
  Component,
  ojs,
  app,
  State,
} from "modular-openscriptjs";
import {
  either,
  monetary,
} from "../../helpers";
import { dc } from "../../declarations";

const h = app("h");
const userCurrency = dc.userCurrency;

export default class SearchResultProductView extends Component {
  render(product, ...args) {
    const p = product instanceof State ? product.value : product;
    if (!p?.id) return h.empty();

    const hasImage = p.images && p.images.length > 0;
    let imagePath = hasImage ? p.images[0].path : p.thumbnail_path;
    const finalHasImage = !!imagePath;

    const ownerName = p.company?.name || p.owner?.name || "Carata Seller";
    const price = p.final_price || p.selling_price || p.price;

    return h.div(
      {
        role: 'button',
        class:
          "search-result-card overflow-hidden rounded-4 bg-white transition-all hover-shadow border shadow-sm",
        style:
          "display: grid; grid-template-columns: 100px 1fr; min-height: 100px;",
        onclick: h.func("app('router').to", "product.view-product", { productId: p.id })
      },

      // Image Section
      h.div(
        {
          class: "overflow-hidden",
          style: "background: #f8f9fa;",
        },
        either(
          finalHasImage,
          () =>
            h.img({
              src: imagePath,
              class: "w-100 h-100 object-fit-cover",
              alt: p.name,
              loading: "lazy",
            }),
          () =>
            h.div(
              {
                class:
                  "w-100 h-100 d-flex flex-column align-items-center justify-content-center p-2 text-center",
              },
              h.i({ class: "bi bi-box2 text-muted opacity-50 fs-3" })
            ),
        ),
      ),

      // Content Section
      h.div(
        {
          class: "p-3 d-flex flex-column justify-content-between",
        },
        h.div(
          h.h6(
            {
              class: "fw-bold text-dark mb-1",
              style: "font-size: 0.95rem;",
            },
            p.name,
          ),
          h.div(
            { class: "text-muted small mb-1" },
            p.short_description ? p.short_description.substring(0, 60) + '...' : "No description."
          )
        ),
        h.div(
          { class: "d-flex align-items-center justify-content-between" },
          h.span(
            { class: "fw-bold text-primary" },
            monetary(price, userCurrency),
          ),
          h.span({ class: "badge bg-light text-dark border small" }, p.status || 'Active')
        ),
      ),
      ...args,
    );
  }
}

ojs(SearchResultProductView);
